<template>
  <div class="articleEditor container">
    <div class="ab">
      <div class="indexData container">
        <article-title/>
        <div class="editorData">
          <form id="form">
            <div class="title">文章信息</div>
            <div class="form_group container">
              <input class="content" @input="descInput('title',80)" type="text" v-model="title" placeholder="请输入标题(不少于5个字)"/>
              <div class="size">{{80-title.length}}</div>
            </div>
            <div class="form_group container">
              <input class="content" @input="descInput('summary',120)" type="text" v-model="summary" placeholder="请输入文章简介(不少于5个字)"/>
              <div class="size">{{120-summary.length}}</div>
            </div>
            <p style="height: 20px;background-color: #F0F0F0;"></p>
            <div class="title">编辑文章</div>
            <div class="form_group container">
              <editor id="editor_id" height="400px" width="950px" :content="editorText"
                      :afterChange="afterChange()"
                      :pluginsPath="pluginsPath"
                      :loadStyleMode="false"
                      :items="items"
                      :resizeType=1
                      filePostName="uploadFile"
                      :uploadJson="uploadJsonUrl"
                      @on-content-change="onContentChange"></editor>
            </div>
            <p style="height: 20px;background-color: #F0F0F0;"></p>
            <div class="title">上传文章封面</div>
            <div class="form_group container">
              <span class="btn fileInputButton">
                <span>
                  <img id="picImg" :src="add_pic" width="261px" height="195px"/>
                  <!--<p>建议封面尺寸：370px*230px</p>-->
                </span>
                <input type="file" name="frontImageFile" class="file img_file" @change="changeFile($event.target)"/>
              </span>
            </div>
            <p style="height: 20px;background-color: #F0F0F0;"></p>
            <div class="title">文章类型</div>
            <div class="articleWay container">
              <el-radio v-model="articleWay" label="Y">原创文章</el-radio>
              <el-radio v-model="articleWay" label="Z">转载文章</el-radio>
              <!--<div><input type="radio" class="radio" value="Y" v-model="articleWay">原创文章</div>-->
              <!--<div><input type="radio" class="radio" value="Z" v-model="articleWay">转载文章</div>-->
            </div>
            <p style="height: 20px;background-color: #F0F0F0;"></p>
            <div class="title">文章标签</div>
            <div class="tabs container">
              <span v-for="tab in tabSelects" @click="tabActive = tab.val"
                    :class="tabActive === tab.val?'active':''" :key="tab.val">{{tab.name}}</span>
            </div>
            <p style="height: 20px;background-color: #F0F0F0;"></p>
            <div class="title">品牌标签</div>
            <div class="tabs container">
              <span v-for="tab in carSelects" @click="carActive = tab;tabInput = ''" :class="carActive === tab?'active':''" :key="tab">{{tab}}</span>
              <span><input class="content" @input="carInput" type="text" v-model="tabInput" placeholder="输入其他品牌"/></span>
            </div>
            <p style="height: 20px;background-color: #F0F0F0;"></p>
            <div class="title">产品标签</div>
            <div class="tabs container">
              <span v-for="tab in cpSelects" @click="cpActive = tab" :class="cpActive === tab?'active':''" :key="tab">{{tab}}</span>
            </div>
            <p style="height: 20px;background-color: #F0F0F0;"></p>
            <div class="title">是否公开</div>
            <div class="articleWay container">
              <el-radio v-model="open" label="true">公开</el-radio>
              <el-radio v-model="open" label="false">秘密</el-radio>
              <!--<div><input type="radio" class="radio" value="true" v-model="open">公开</div>-->
              <!--<div><input type="radio" class="radio" value="false" v-model="open">私密</div>-->
            </div>
          </form>
        </div>
        <div class="submit" @click="submitData">保存</div>
      </div>
    </div>
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </div>
</template>

<script>
import articleTitle from '../common/articleTitle.vue'
import loading from '../common/loading.vue'
export default {
  name: 'articleEditor',
  data () {
    return {
      msg: '个人首页',
      isLoad: true,
      pluginsPath: './static/kindeditor/plugins/',
      items: [
        'bold', 'link', 'image', 'justifyleft', 'justifycenter', 'justifyright', 'fontsize'
      ],
      tabSelects: [{
        val: 'DG_AL',
        name: '灯改案例'
      }, {
        val: 'CP_AL',
        name: '产品推荐'
      }],
      carSelects: [
        '奥迪', '宝马', '大众'
      ],
      cpSelects: [
        'D40', 'D32', 'D26', '倒车灯', '示宽灯', '阅读灯', '刹车灯'
      ],
      articleId: '',
      tabActive: '',
      tabInput: '',
      carActive: '',
      cpActive: '',
      title: '',
      summary: '',
      editorText: '',
      uploadJsonUrl: 'http://www.naolamp.cn/sale/bbs/common/upload?callBackPath=http://' + document.domain + '/redirect.html',
      articleWay: 'Y',
      open: 'true',
      add_pic: require('../../assets/image/upload_file.jpg')
    }
  },
  computed: {
  },
  mounted: function (s) {
    console.log(this.uploadJsonUrl)
    this.isLoad = false
    let qo = this.$route.query
    if (qo.articleId) {
      this.articleId = qo.articleId
      let that = this
      that.axios.post('/topic/editDetail', {
        articleId: that.articleId
      }, {
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          let article = response.data.value
          that.tabActive = article.tab
          that.cpActive = article.cpTab
          that.carActive = article.carTab
          that.tabInput = article.carTab
          that.title = article.title
          that.summary = article.summary
          that.articleWay = article.articleWay
          that.open = article.open + ''
          that.editorText = article.content
          if (article.frontImage) {
            that.add_pic = article.frontImage
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  methods: {
    carInput: function () {
      if (this.tabInput && this.tabInput.length > 0) {
        this.carActive = ''
      }
    },
    descInput: function (el, len) {
      if (this[el] && this[el].length > len) {
        this[el] = this[el].substr(0, len)
      }
    },
    submitData: function () {
      let form = document.getElementById('form')
      let that = this
      let formData = new FormData(form)
      formData.append('userId', this.$store.state.user.userId)
      formData.append('tab', this.tabActive)
      formData.append('articleId', this.articleId)
      formData.append('cpTab', this.cpActive)
      if (this.tabInput && this.tabInput.length > 0) {
        formData.append('carTab', this.tabInput)
      } else {
        formData.append('carTab', this.carActive)
      }
      // console.log(this.editorText)
      // formData.append('content', this.editorText)
      formData.append('title', this.title)
      formData.append('summary', this.summary)
      formData.append('articleWay', this.articleWay)
      formData.append('open', this.open)
      that.axios.post('topic/save', formData, {
        headers: {},
        mimeType: 'multipart/form-data'
      }).then(function (response) {
        that.loading = false
        if (response.data.status === 0) {
          that.$store.commit('setToastMsg', '保存成功')
          that.$router.push({name: 'articleDetail', params: { articleId: response.data.value }})
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    'changeFile': function (e) {
      let that = this
      if (e.value && e.files[0]) {
        console.log(e.value)
        var file = e.files[0]
        var reader = new FileReader()
        reader.onload = function (e) {
          var data = e.target.result
          that.add_pic = data
        }
        reader.readAsDataURL(file)
      }
    },
    onContentChange (val) {
      this.editorText = val
    },
    afterChange () {
    }
  },
  filters: {},
  components: {
    articleTitle,
    loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.articleEditor {
  padding-top: 52px;
}
.ab {
  width: 100%;
  min-width: 1200px;
  background-color: #F0F0F0;
  padding-bottom: 50px;
}
.indexData {
  margin: 0 auto;
  width: 1200px;
  margin-top: 10px;
  text-align: left;
  height: auto;
  font-size: 16px;
  color: #333333;
}
.editorData {
  text-align: left;
  background-color: #FFFFFF;
  width: 1200px;
  padding-top: 10px;
  min-height: 930px;
}
.editorData .title {
  padding: 15px 0 15px 30px;
  width: 1170px;
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  font-family: FZYH_510M;
  color: #333333;
  border-bottom: 1px solid #d2d2d2;
}
.editorData .form_group {
  position: relative;
  margin: 20px;
  box-sizing: border-box;
}
.editorData .form_group input{
  padding: 0 15px;
  background-color: #F0F0F0;
  line-height: 50px;
  width: 950px;
  float: left;
  /*font-size: 16px;*/
  margin-bottom: 20px;
  box-sizing: border-box;
}
.editorData .form_group .size{
  background-color: #F0F0F0;
  /*float: left;*/
  position: absolute;
  right: 225px;
  line-height: 50px;
  width: 30px;
  font-size: 16px;
  color: #888888;
  text-align: right;
  /*font-family: "SourceHanSansCN-Normal";*/
}

.fileInputButton {
  position: relative;
  display: inline-block;
  overflow: hidden;
}
.fileInputButton input{
  position:absolute;
  right: 0px;
  top: 0px;
  opacity: 0;
  -ms-filter: 'alpha(opacity=0)';
  font-size: 200px;
}
.fileInputButton span p{
  text-align: center;
  font-size: 7px;
  margin-top: 10px;
}
.articleWay{
  padding-bottom: 20px;
  box-sizing: border-box;
}
.articleWay,.tabs {
  margin: 20px;
}
.articleWay div,.openWay div {
  padding-top: 2px;
  float: left;
  width: 150px;
  line-height: 50px;
  text-align: center;
}
.articleWay div input:checked {
  background-color: #05b570;
  color: #05b570;
}
.tabs span {
  cursor: pointer;
  float: left;
  line-height: 51px;
  text-align: center;
  margin-right: 20px;
  background-color: #F0F0F0;
  color: #787d82;
  width: 115px;
  font-size: 16px;
  font-family: "SourceHanSansCN-Normal";
}
.tabs input {
  font-size: 16px;
  line-height: 51px;
  background-color: #F0F0F0;
  color: #787d82;
  padding: 0 8px;
  /*text-align: center;*/
  box-sizing: border-box;
  font-family: "SourceHanSansCN-Normal";
}
.tabs span.active {
  color: #FFFFFF;
  background-color: #05b570;
}
.submit {
  color: #fff;
  background-color: #05b570;
  font-size: 16px;
  line-height: 42px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px solid transparent;
  width: 190px;
  text-align: center;
}
</style>
<style>
  .ab .el-radio__input.is-checked .el-radio__inner{
    border-color: #05b570;
    background-color: #05b570;
  }
  .ab .el-radio__input.is-checked+.el-radio__label{
    color: #333;
  }
  .ab .el-radio__inner {
    border: 1px solid #dcdfe6;
    border-radius: 100%;
    width: 14px;
    height: 14px;
    background-color: #fff;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .ab .el-radio__inner:hover{
    border-color: #05b570;
  }
  .ab .el-radio__label {
    font-size: 16px;
    padding-left: 10px;
    font-family: "SourceHanSansCN-Normal";
  }
</style>



// WEBPACK FOOTER //
// src/components/article/articleEditor.vue